import { attachVimeoAnalytics } from "@/utils/vimeoAnalytics/vimeoAnalytics";
import { VIDEO_STARTED, VIDEO_PROGRESS, VIDEO_COMPLETED, VIDEO_PAUSED, VIDEO_SEEKED, VIDEO_CAPTIONS_CHANGED, VIDEO_FULLSCREEN_CHANGED, VIDEO_ENTER_PICTURE_IN_PICTURE, VIDEO_LEAVE_PICTURE_IN_PICTURE, VIDEO_QUALITY_CHANGED, VIDEO_PLAYBACK_RATE_CHANGED, VIDEO_VOLUME_CHANGED, VIDEO_BUFFER_START, VIDEO_BUFFER_END, } from "@/utils/analyticsEvents";
export default {
    name: "TrainingPlanVideo",
    props: {
        classItem: { type: Object, required: true },
    },
    data() {
        return {
            videoReload: false,
            disclaimerVisible: false,
            vimeoPlayer: null,
        };
    },
    mounted() {
        this.initVimeoAnalytics();
    },
    beforeDestroy() {
        if (this.vimeoPlayer) {
            this.vimeoPlayer.destroy();
            this.vimeoPlayer = null;
        }
    },
    watch: {
        classItem() {
            if (this.vimeoPlayer) {
                this.vimeoPlayer.destroy();
                this.vimeoPlayer = null;
            }
            this.initVimeoAnalytics();
        },
    },
    methods: {
        initVimeoAnalytics() {
            this.$nextTick(() => {
                const videoWrapElement = this.$refs.videoWrap;
                if (!videoWrapElement)
                    return;
                this.vimeoPlayer = attachVimeoAnalytics(videoWrapElement, {
                    video_id: this.classItem.id,
                    video_title: this.classItem.title,
                    content_type: "training_plan",
                    video_category: "Digital Gym",
                }, {
                    videoStartedEvent: VIDEO_STARTED,
                    videoProgressEvent: VIDEO_PROGRESS,
                    videoCompletedEvent: VIDEO_COMPLETED,
                    videoPausedEvent: VIDEO_PAUSED,
                    videoSeekedEvent: VIDEO_SEEKED,
                    videoCaptionsChangedEvent: VIDEO_CAPTIONS_CHANGED,
                    videoFullscreenChangedEvent: VIDEO_FULLSCREEN_CHANGED,
                    videoEnterPictureInPictureEvent: VIDEO_ENTER_PICTURE_IN_PICTURE,
                    videoLeavePictureInPictureEvent: VIDEO_LEAVE_PICTURE_IN_PICTURE,
                    videoQualityChangedEvent: VIDEO_QUALITY_CHANGED,
                    videoPlaybackRateChangedEvent: VIDEO_PLAYBACK_RATE_CHANGED,
                    videoVolumeChangedEvent: VIDEO_VOLUME_CHANGED,
                    videoBufferStartEvent: VIDEO_BUFFER_START,
                    videoBufferEndEvent: VIDEO_BUFFER_END,
                });
            });
        },
    },
    computed: {
        decodedEmbed() {
            return this.classItem.video_url ? atob(this.classItem.video_url) : "";
        },
        componentText() {
            return this.getText.liveEvent;
        },
    },
};
